
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IInfoCardData, IInfoTableRow, ISearchCriteria, ISearchService } from "@tylertech/tyler-api-types";

/**
 * MeterSearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class MeterSearchService {
    private readonly $apiService = inject(ApiService);
    
    GetCriteria(): Promise<ISearchCriteria<IInfoCardData>> {
        return this.$apiService.sendAuth("IMeterSearchService/GetCriteria");
    }
    PerformAction(pCriteria: IInfoTableRow[]): Promise<string> {
        return this.$apiService.sendAuth("IMeterSearchService/PerformAction", pCriteria);
    }
    Search(pCriteria: ISearchCriteria<IInfoCardData>): Promise<ISearchCriteria<IInfoCardData>> {
        return this.$apiService.sendAuth("IMeterSearchService/Search", pCriteria);
    }
}
